module.exports = __webpack_public_path__ + "website/img/imgo_2.61b62432.png";